import PropTypes from 'prop-types';

export const pressReleaseTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    featuredImage: PropTypes.shape({
        image: PropTypes.shape({
            fluid: PropTypes.object.isRequired,
        }).isRequired,
        description: PropTypes.string,
    }),
};
